import { Link } from 'react-router-dom';
import { PrimaryLogo } from './PrimaryLogo.js';

export function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer__inner">
        <PrimaryLogo variant="jpg" displayWidth={160} className="public-footer__logo" />
        <p className="public-footer__tagline">
          Clinical case tracking and clinical-document workflow for Surgical Technology programs.
        </p>
        <nav className="public-footer__links" aria-label="Footer">
          <Link to="/login">Sign In</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/support">Support</Link>
        </nav>
        <p className="public-footer__legal">
          © {new Date().getFullYear()} ScrubLedger. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
